<template>
  <div id="Warehousetable">
    <el-dialog
      title="选择部门"
      width="1000px"
      append-to-body
      @close="closeDialog"
      :visible.sync="visible"
      :show="show"
      :close-on-click-modal="false"
    >
      <div class="searchbox">
        <inputOne
          class="base_select_sty185 isdisable"
          name="搜索"
          :v-model="search"
          :isMust="false"
          field="search"
          placeholder="输入助记码/编号/名称"
          @changeVal="dateChange"
          @keyup.enter.native="searchclick"
        />
        <el-button type="primary" size="mini" icon="el-icon-search" @click="searchclick">查询</el-button>
        <!-- <div class="Multiple_selection" v-if="ifshow">
          <el-checkbox-group v-model="checkList" @change="changecheckStop">
            <el-checkbox label="显示层次结构"></el-checkbox>
          </el-checkbox-group>
        </div>-->
      </div>
      <div v-if="isshows" class="imgloading">
        <div class="imgloading_box">
          <img src="@/assets/timg.gif" alt />
        </div>
      </div>
      <Warehousetable
        show_Select
        :showSelect="false"
        :ShowSummary="false"
        v-if="!isshows"
        :heights="false"
        :ObtainHeader="Obtain"
        :columnS="false"
        :tableData="tableData"
        :isInners="isInner"
        @clickIcon="clickIcons"
        @dblclick="dblclick"
        @rowclick="rowclick"
        class="righttagBox"
      />
      <div class="button">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible">确 定</el-button>
      </div>
      <div>
        <el-pagination
          @size-change="handleSizeChanges"
          @current-change="handleCurrentChanges"
          :current-page="currentPages"
          :page-sizes="[10, 20,50,100]"
          :page-size="pageSizes"
          layout="total, sizes,prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import treehistory from "@/components/Warehousetable/Warehousetable.vue";
// import InputOne from "@/components/base/InputOne/InputOne.vue";
import tool from "@/utils/tool.js";
export default {
  components: {
    // treehistory,
    // InputOne
  },
  data() {
    return {
      currentPages: 1, //当前页码
      totals: 0, //总页数
      pageSizes: 10, //每页显示数量
      visible: this.show,
      search: "",
      data: [],
      Obtain: [],
      tableData: [],
      isshows: true,
      ifshow: false,
      dialogVal: {},
      isInner: "el-icon-s-tools",
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    dialogVisible() {
      console.log(this.dialogVal);
      this.visible = false;
      this.$emit("dataname", this.dialogVal);
    },
    // 关闭弹出框前回调
    closeDialog() {
      this.$emit("update:show", false);
      this.search = "";
    },
    dateChange(data, text) {
      this[text] = data;
    },
    changecheckStop(val) {},

    // 分页
    getListByPages() {
      // 收集参数
      let params = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        pagesize: this.pageSizes, //每页显示数量
        pagenum: this.currentPages, //当前页码
        Keywords: this.search,
      };
      let jparams = JSON.stringify(params);
      let jparams_history = { jparams: jparams };
      // 向后端发送请求
      this.request
        .post("/index/Department/getAll", jparams_history)
        .then((res) => {
          // 接收后端发送回来的数据
          let { status, count, data } = res;
          if (status == 0) {
            // 赋值给页面总条数
            this.totals = count;
            this.tableData = data;
          }
          // 判断当前页中数据是否为空，或当前页是否为第一页
          if (data.length === 0 && this.currentPages !== 1) {
            this.currentPages -= 1;
            // 调用自己
            this.getListByPages();
          }
        });
    },
    handleSizeChanges(val) {
      this.pageSizes = val;
      if (this.search == "") {
        this.getListByPages();
      } else {
        this.searchbtn();
      }
    },
    handleCurrentChanges(val) {
      this.currentPages = val;
      if (this.search == "") {
        this.getListByPages();
      } else {
        this.searchbtn();
      }
    },
    // 获取表头
    ObtainHeader() {
      let userid = tool.getLocal("userid");
      let sessionid = tool.getLocal("sessionid");
      let params = {
        user_id: userid, //用户id
        session_id: sessionid, //用户凭证
        Model: "Department",
      };
      let jparams = JSON.stringify(params);
      let jparams_Header = { jparams: jparams };
      this.request
        .post("/index/Settings/get_function_fields", jparams_Header)
        .then((res) => {
          let { status, data } = res;
          // this.Obtain = [];
          this.Obtain = data.body;
          this.isshows = false;
        });
    },
    // 单击行
    rowclick(val, e) {
      console.log(e);
      this.dialogVal = val;
      if (e == "确定") {
        this.dialogVisible();
      }
    },
    // 双击行
    dblclick(obj) {
      if (!obj.IsDir) {
        this.visible = false;
        this.$emit("dataname", obj);
      } else if (obj.IsDir) {
        this.dataslist = obj.DeptId;
        let userid = tool.getLocal("userid");
        let sessionid = tool.getLocal("sessionid");
        let params = {
          user_id: userid, //用户id
          session_id: sessionid, //用户凭证
          ParentNo: obj.DeptId, //父类id
        };
        let jparams = JSON.stringify(params);
        let jparams_ParentNo = { jparams: jparams };
        this.request
          .post("/index/Department/search", jparams_ParentNo)
          .then((res) => {
            let { status, data, count } = res;
            if (status == 0) {
              // 总条数
              this.total = count;
              this.tableData = data;
              this.isInner = "el-icon-refresh-left";
            }
          });
      }
    },
    clickIcons() {
      if (this.isInner == "el-icon-refresh-left") {
        this.isInner = "el-icon-s-tools";
        this.getListByPages();
      } else if (this.isInner == "el-icon-s-tools") {
        this.$message({
          showClose: true,
          message: "不可修改表头信息",
          type: "warning",
        });
      }
    },
    searchclick() {
      this.currentPages = 1;
      if (this.search == "") {
        this.getListByPages();
      } else {
        // 收集参数
        let params = {
          user_id: tool.getLocal("userid"), //用户id
          session_id: tool.getLocal("sessionid"), //用户凭证
          pagesize: this.pageSizes, //每页显示数量
          pagenum: this.currentPages, //当前页码
          Keywords: this.search,
        };
        this.request
          .post("/index/Department/search", { jparams: JSON.stringify(params) })
          .then((res) => {
            // 接收后端发送回来的数据
            let { status, count, data } = res;
            if (status == 0) {
              // 赋值给页面总条数
              this.totals = count;
              // 赋值给表格数据
              this.tableData = data;
            }
            // 判断当前页中数据是否为空，或当前页是否为第一页
            if (data.length === 0 && this.currentPages !== 1) {
              this.currentPages -= 1;
              // 调用自己
              this.searchbtn();
            }
          });
      }
    },
    searchbtn() {
      if (this.search == "") {
        this.currentPages = 1;
        this.getListByPages();
      } else {
        // 收集参数
        let params = {
          user_id: tool.getLocal("userid"), //用户id
          session_id: tool.getLocal("sessionid"), //用户凭证
          pagesize: this.pageSizes, //每页显示数量
          pagenum: this.currentPages, //当前页码
          Keywords: this.search,
        };
        this.request
          .post("/index/Department/search", { jparams: JSON.stringify(params) })
          .then((res) => {
            // 接收后端发送回来的数据
            let { status, count, data } = res;
            if (status == 0) {
              // 赋值给页面总条数
              this.totals = count;
              // 赋值给表格数据
              this.tableData = data;
            }
            // 判断当前页中数据是否为空，或当前页是否为第一页
            if (data.length === 0 && this.currentPages !== 1) {
              this.currentPages -= 1;
              // 调用自己
              this.searchbtn();
            }
          });
      }
    },
  },
  created() {},
  watch: {
    show() {
      this.visible = this.show;
      if (this.visible == true) {
        this.isshows = true;
        this.ObtainHeader();
        this.getListByPages();
      }
    },
    // "$attrs.watchname": {
    //   handler(newValue, oldValue) {
    //     console.log(newValue);
    //     if (newValue == "1" || ) {

    //     }
    //   }
    // }
  },
};
</script>

<style lang="less">
.righttagBox {
  height: 87% !important;
}
.el-dialog__body {
  overflow: hidden;
}
.button {
  position: absolute;
  left: 854px;
  bottom: 9px;
  width: 158px;

  .el-button {
    padding: 6px 14px;
  }
}
.imgloading {
  .imgloading_box {
    width: 300px;
    margin: 0 auto;
    img {
      width: 300px;
    }
  }
}
.searchbox {
  display: flex;
  margin-bottom: 5px;
  .base_select_sty185 {
    width: 200px;
    margin-right: 15px;
  }
  .el-button {
    .el-button--mini,
    .el-button--mini.is-round {
      padding: 7px 4px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/department/department.vue